export { default as AlertDialog } from './AlertDialog';
export type {
  AlertDialogProps,
  AlertDialogBodyProps,
  AlertDialogCloseButtonProps,
  AlertDialogContentProps,
  AlertDialogFooterProps,
  AlertDialogHeaderProps,
} from './types';
